import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorBoundarySuspense } from 'src/components/suspenses/ErrorBoundarySuspense';
import { ConfigurationCriteriaProducts } from 'src/features/configuration/configurationCriteria/configurationCriteriaProducts/ConfigurationCriteriaProducts';
import { ConfigurationCriteriaProductsSkeleton } from 'src/features/configuration/configurationCriteria/configurationCriteriaProducts/ConfigurationCriteriaProductsSkeleton';
import { QUERY_KEY_SCOPE_PURCHASE_PRODUCTS } from 'src/keys';

export function ConfigurationCriteriaProductsContainer(): ReactElement {
  const { t } = useTranslation('configuration');

  return (
    <ErrorBoundarySuspense
      loadingFallback={<ConfigurationCriteriaProductsSkeleton />}
      errorFallbackWrapper={<div />}
      message={t('Error while fetching the eligible products')}
      queryKey={[QUERY_KEY_SCOPE_PURCHASE_PRODUCTS]}
    >
      <ConfigurationCriteriaProducts />
    </ErrorBoundarySuspense>
  );
}
